import React from 'react';
import Link from 'next/link';

const GSTStripCommonData = {
  GSTPlans: [
    {
      stripText: "15% Exclusive discount on ReAssure 3.0",
      redirectionUrl: "https://www.nivabupa.com/"
    },
    {
      stripText: "15% Exclusive discount on ReAssure 3.0",
      redirectionUrl: "https://www.nivabupa.com/"

    },
    {
      stripText: "15% Exclusive discount on ReAssure 3.0",
      redirectionUrl: "https://www.nivabupa.com/"

    },
    {
      stripText: "15% Exclusive discount on ReAssure 3.0",
      redirectionUrl: "https://www.nivabupa.com/"

    },
    {
      stripText: "15% Exclusive discount on ReAssure 3.0",
      redirectionUrl: "https://www.nivabupa.com/"

    },
  ],
};


function GSTStripCommon({ infoStrip }) {
  let stripData = Object.keys(infoStrip).length>0 ? Array(8).fill(infoStrip) : GSTStripCommonData.GSTPlans
  return (
    <div className='sticky z-10  px-0 py-2 overflow-x-auto top-[60px] md:py-2 md:px-12 bg-nivabupa-blue-ethinosPlanRecommendation'>
      <div className="group overflow-hidden whitespace-nowrap mx-auto max-w-[1280px] w-full">
        <div className="group-hover:[animation-play-state:paused] flex flex-row justify-between gap-7 whitespace-nowrap animate-marquee" style={{ animationDuration: '50s' }}>
          {stripData.map((item, index) => (
            <>
              <Link href={item.redirectionUrl} target="_blank" className='text-white text-center md:min-w-[70%] min-w-[100%]'>{item.stripText}</Link>
            </>
          ))}
        </div>
      </div>
    </div>
  );
}

export default GSTStripCommon;